module.exports = __webpack_public_path__ + "static/img/carousel_2_klrq02_ar_16_9_w_1747.252c5b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/carousel_2_klrq02_ar_16_9_w_1747.jpg
// module id = NtsG
// module chunks = 0